<template>
    <teleport :to="targetClass">
        <component :is="component" v-bind="componentProps || {}" />
    </teleport>
</template>

<script setup lang="ts">
    import { defineProps } from "vue";

    defineProps<{
        component: any;
        componentProps?: Record<string, any>;
        targetClass: string; // unique selector for teleport
    }>();
</script>
